import { useEffect } from "react";
import "./AppPTOSchedule.css";
import { Calendar } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { selectUIStates, setUIStates } from "../../../redux/features/appData";

type AppPTOScheduleProps = {
}

export const AppPTOSchedule = ({}: AppPTOScheduleProps) => {
    const dispatch = useDispatch();
    const uiStates = useSelector(selectUIStates);

    useEffect(() => {
        dispatch(setUIStates({...uiStates, hrisLocation: "PTO Schedule"}));
    }, []);

    return (
        <div className="app-pto-schedule">
            
            <div className="app-pto-schedule-content">
                <div className="app-pto-schedule-zero-state">
                    <div className="app-pto-schedule-zero-state-icon">
                        <Calendar size={48} />
                    </div>
                    <h3 className="app-pto-schedule-zero-state-title">No PTO Schedule Found</h3>
                    <p className="app-pto-schedule-zero-state-description">
                        There are no scheduled time off events in your workspace.
                    </p>
                </div>
            </div>
        </div>
    )
}